import React from "react";
import {Flex, Heading} from "@adobe/react-spectrum";

function SectionAbout() {
    return (
        <Flex direction="column" gap="size-150">
            <Heading level={2} id="about">Joyful exploration</Heading>
            <p className="fs-16">
                Crayon boxes help us mentally organize and easily use color, but to fathom the infinite possibilities of light we turn to the color wheel. Likewise, font menus are useful and help us stay organized —but type is practically infinite, full of wonder and possibility. What if we could move around more freely?
                <br/><br/>
                Under the hood, this prototype uses ongoing machine learning from Adobe Research to map fonts by visual similarity in many dimensions. We flattened that into two dimensions, then normalized font sizes so text won’t jump around as much when exploring. We want to see how this feels.
            </p>
        </Flex>
    );
}

export default SectionAbout;